// extracted by css-extract-rspack-plugin
export default {"cls1":"LoggedInDiscoveryPage-cls1_e8r","cls2":"LoggedInDiscoveryPage-cls2_Uib LoggedInDiscoveryPage-cls1_e8r"};